export default "__VITE_ASSET__514e2aa5__"